import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import i18next from "i18next";
import toastr from 'toastr';
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";

const labelStyle = {"border-bottom": "1px dashed #00321e"};
const labelClass = "col-md-2 col-sm-6";

class ApiAccess extends Component {
    constructor(props, context) {
        super(props, context);

        toastr.options = {
            "closeButton": false,
            "debug": false,
            "newestOnTop": false,
            "progressBar": false,
            "positionClass": "toast-top-center",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "4000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        }
    }

    async componentDidMount() {
        await this.props.dispatch(this.props.getTokenInfo.initialize());
    }

    activateApi = async (isPasswordChange = false) => {

        if  (!isPasswordChange)
            await confirm(i18next.t("ApiEnableAccessAsk"))
        else
            await confirm(i18next.t("ApiNewKeyAsk"))

        await this.props.dispatch(this.props.setTokenInfo.execute());
        if (!this.props.setTokenInfo.isError)
            await this.props.dispatch(this.props.getTokenInfo.execute());
    }

    async componentWillUnmount() {
        await this.props.dispatch(this.props.setTokenInfo.reset());
    }

    copyString = async (stringData) => {

        if (navigator.clipboard) {
            await navigator.clipboard.writeText(stringData);
            toastr.success(i18next.t("ApiCopy"));
        }
    }

    render() {

        const isApiInitialized = this.props.getTokenInfo.rowsCount() > 0;
        const isApiActive = isApiInitialized > 0 && this.props.getTokenInfo.getRow(0)["Gen_Active"];

        const clientId = this.props.getTokenInfo.getRow(0)["External_DESourceName"];

        let password = this.props.getTokenInfo.getRow(0)["Acc_Password"];
        let passwordHidden = true;

        if (this.props.setTokenInfo.isInitialized && this.props.setTokenInfo.rowsCount() > 0) {
            password = this.props.setTokenInfo.getRow(0)["Acc_Password"];
            passwordHidden = false;
        }

        const passwordComment = passwordHidden ? i18next.t("ApiHidden") :
            i18next.t("ApiSaveValue");

        return <div>
            <div className="row" style={{marginTop: "10px", marginBottom: "10px"}}>
                <div className="col-md-9">
                    <h1 className="page-title">
                        {i18next.t("ApiAccessSetup")}
                    </h1>
                </div>
            </div>
            <div style={{marginLeft: "20px", marginBottom: "10px"}}>
                <div className="row" style={{marginBottom: "10px"}}>
                    <div className={labelClass} style={labelStyle}>{i18next.t("ApiStatus")}
                    </div>
                    <div className="col-md-2 col-sm-6 font-weight-bold">{isApiActive ? i18next.t("ApiEnabled") : i18next.t("ApiNotEnabled")}
                    </div>
                </div>
                {!isApiInitialized ?
                    (<div className="row" style={{marginBottom: "10px"}}>
                        <div className={labelClass}/>
                        <div className={labelClass}>
                            <button type="button" className="btn btn-regular"
                                    onClick={async()=>await this.activateApi(false)}>{i18next.t("ApiEnable")}</button>
                        </div>
                    </div>)
                    :
                    (
                        <>
                            <div className="row" style={{marginBottom: "10px"}}>
                                <div className={labelClass} style={labelStyle}>{i18next.t("ApiClientId")}</div>
                                <div
                                    className="col-md-2 col-sm-6 font-weight-bold">{clientId ? (
                                    <>{clientId}&nbsp;<span className="fa fa-copy" style={{cursor: "pointer"}}
                                                            onClick={() => this.copyString(clientId)}/>
                                    </>) : i18next.t("ApiNotActive")}
                                </div>
                            </div>
                            <div className="row" style={{marginBottom: "10px"}}>
                                <div className={labelClass} style={labelStyle}>{i18next.t("ApiSecretKey")}</div>
                                <div className="col-md-10 col-sm-6">
                                    <span className="font-weight-bold">
                                        {(password && passwordHidden) && password}
                                        {(password && !passwordHidden) && <>{password}&nbsp;<span className="fa fa-copy" style={{cursor: "pointer"}}
                                                                                                  onClick={() => this.copyString(password)}/></>}
                                        {!password && i18next.t("ApiNotActive")}
                                    </span>
                                    &nbsp;&nbsp;{passwordComment}
                                </div>
                            </div>
                            <div className="row" style={{marginBottom: "10px"}}>
                                <div className={labelClass}/>
                                <div className={labelClass}>
                                    <button type="button" className="btn btn-regular"
                                            onClick={async () => await this.activateApi(true)}>{i18next.t("ApiNewKey")}</button>
                                </div>
                            </div>
                        </>
                    )}
            </div>
        </div>
    }
}

ApiAccess.propTypes = {
    dispatch: PropTypes.func.isRequired
};


ApiAccess.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        setTokenInfo: state.apiState.setTokenInfo,
        getTokenInfo: state.apiState.getTokenInfo,
    };
}

export default connect(mapStateToProps)(ApiAccess)